export const apiCreate = (): string => '/commercial/partners/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/partners/' : `/commercial/partners/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/partners/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/partners/delete/${id}`
